import { render, staticRenderFns } from "./Distribucion.vue?vue&type=template&id=7cff5b92"
import script from "./Distribucion.vue?vue&type=script&lang=js"
export * from "./Distribucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports